var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0C2.67188 0 2 0.671875 2 1.5V14.5C2 15.3281 2.67188 16 3.5 16H6.5V13.5C6.5 12.6719 7.17188 12 8 12C8.82812 12 9.5 12.6719 9.5 13.5V16H12.5C13.3281 16 14 15.3281 14 14.5V1.5C14 0.671875 13.3281 0 12.5 0H3.5ZM4 7.5C4 7.225 4.225 7 4.5 7H5.5C5.775 7 6 7.225 6 7.5V8.5C6 8.775 5.775 9 5.5 9H4.5C4.225 9 4 8.775 4 8.5V7.5ZM7.5 7H8.5C8.775 7 9 7.225 9 7.5V8.5C9 8.775 8.775 9 8.5 9H7.5C7.225 9 7 8.775 7 8.5V7.5C7 7.225 7.225 7 7.5 7ZM10 7.5C10 7.225 10.225 7 10.5 7H11.5C11.775 7 12 7.225 12 7.5V8.5C12 8.775 11.775 9 11.5 9H10.5C10.225 9 10 8.775 10 8.5V7.5ZM4.5 3H5.5C5.775 3 6 3.225 6 3.5V4.5C6 4.775 5.775 5 5.5 5H4.5C4.225 5 4 4.775 4 4.5V3.5C4 3.225 4.225 3 4.5 3ZM7 3.5C7 3.225 7.225 3 7.5 3H8.5C8.775 3 9 3.225 9 3.5V4.5C9 4.775 8.775 5 8.5 5H7.5C7.225 5 7 4.775 7 4.5V3.5ZM10.5 3H11.5C11.775 3 12 3.225 12 3.5V4.5C12 4.775 11.775 5 11.5 5H10.5C10.225 5 10 4.775 10 4.5V3.5C10 3.225 10.225 3 10.5 3Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.2a36838b9996775114b02e39cbb135af.svg";
export { ForwardRef as ReactComponent };